import { API_URL } from "../../constants/app";
import {
  headersJsonToken,
  headersFormDataToken,
  headersToken,
} from "./requestHeaders";

export async function getUsers({ queryKey, pageParam = 1 }) {
  let payload = queryKey[1];
  payload = { page: pageParam, ...payload };
  let res = await fetch(`${API_URL}/user/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      let userRoleList = [];
      data.body.data.forEach((user, i) => {
        modifiedData.push({
          n: i + 1,
          value: user.id,
          firstName: user.firstName,
          lastName: user.lastName,
          gender: user.gender === 1 ? "Male" : "Famale",
          label: user.username,
          createdDate: user.createdDate,
          userRoleList: user?.userRoleList.map((role) => ({
            ...userRoleList,
            value: role.id,
            label: role.name,
          })),
          createdByUser: user.createdByUser,
        });
      });
      return { modifiedData, pagination: data.body.pagination };
    });
  return res;
}
export async function findUser(payload) {
  let res = await fetch(`${API_URL}/user/find/${payload}`, {
    method: "POST",
    headers: headersJsonToken(),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      let userGroup = [];
      let userZone = [];
      let user = data.body.data[0];
      modifiedData = {
        id: user.id,
        username: user.username,
        firstName: user.firstName,
        lastName: user.lastName,
        gender: user.gender === 1 ? "Male" : "Female",
        dateOfBirth: new Date(user.dateOfBirth),
        telephone: user.telephone,
        date: new Date(user.date),
        userGroup: user.userRoleList.map((user) => ({
          ...userGroup,
          value: user.id,
          label: user.name,
        })),
        userZone: user.userZoneLists.map((zone) => ({
          ...userZone,
          value: zone.id,
          label: zone.name,
        })),
      };
      return modifiedData;
    });
  return res;
}

export async function addUser(payload) {
  let res = await fetch(`${API_URL}/user/add`, {
    method: "POST",
    headers: headersFormDataToken(),
    body: payload,
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function editUser(payload) {
  let res = await fetch(`${API_URL}/user/update`, {
    method: "POST",
    headers: headersFormDataToken(),
    body: payload,
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function deleteUser(id) {
  let res = await fetch(`${API_URL}/user/delete/${id}`, {
    method: "POST",
    headers: headersToken(),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function changePasswordUser(formData) {
  let res = await fetch(`${API_URL}/user/change-password`, {
    method: "POST",
    headers: headersToken(),
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}

